export const makeApiUrl = (url: string): string => {
  return (!window.location.href.includes('test') && !window.location.href.includes('localhost')) ? 'https://api.glassen-it.com/component/socparser' : 'https://api.glassen-it.com/component/socparser'
}
